import Clipboard from "../assets/svgIcons/clipboard-check.svg";
import ListDetails from "../assets/svgIcons/list-details.svg";
import MailOpened from "../assets/svgIcons/mail-opened.svg";
import IdIcon from "../assets/svgIcons/id.svg";
import FileText from "../assets/svgIcons/file-text.svg";
import FileCheck from "../assets/svgIcons/file-check.svg";

export interface StepData {
  icon: any; // <-- string, not ReactNode
  title: string;
  steplable?: string;
  displayText?: string;
}

export const applicationStepsData: StepData[] = [
  {
    icon: Clipboard,
    title: "Eligibility Check",
    steplable: "Step 1",
    displayText: "",
  },
  {
    icon: ListDetails,
    title: "Applicant & Loan Details",
    steplable: "Step 2",
    displayText: "",
  },
  {
    icon: MailOpened,
    title: "Provisional Offer Letter",
    steplable: "Step 3",
    displayText: "",
  },
  {
    icon: IdIcon,
    title: "Additional Details & Documents",
    steplable: "Step 4",
    displayText: "",
  },
  {
    icon: FileText,
    title: "Final Verification & Sanction",
    steplable: "Step 5",
    displayText: "",
  },
  {
    icon: FileCheck,
    title: "Disbursement of Funds",
    steplable: "Step 6",
    displayText: "",
  },
];
